// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.invitation-page {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  padding: 20px;
}

.invitation-card {
  background: white;
  border-radius: 16px;
  padding: 48px;
  max-width: 600px;
  width: 100%;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);
}

.invitation-header {
  text-align: center;
  margin-bottom: 32px;
}

.invitation-icon {
  font-size: 64px;
  margin-bottom: 16px;
}

.invitation-header h1 {
  font-size: 32px;
  color: #333;
  margin: 0;
}

.invitation-body {
  margin-bottom: 32px;
}

.invitation-intro {
  font-size: 18px;
  line-height: 1.6;
  color: #555;
  margin-bottom: 24px;
}

.role-badge {
  display: inline-block;
  background: #f0f0f0;
  padding: 4px 12px;
  border-radius: 12px;
  font-size: 14px;
  color: #667eea;
  font-weight: 600;
}

.offering-name {
  font-size: 28px;
  color: #667eea;
  margin: 24px 0;
  text-align: center;
}

.invitation-details {
  font-size: 16px;
  line-height: 1.6;
  color: #666;
  margin-bottom: 24px;
}

.invitation-email {
  background: #f8f9fa;
  padding: 16px;
  border-radius: 8px;
  text-align: center;
}

.invitation-email p {
  margin: 0 0 8px 0;
  font-size: 14px;
  color: #888;
}

.invitation-email strong {
  font-size: 16px;
  color: #333;
}

.invitation-actions {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.btn-accept {
  background: #667eea;
  color: white;
  border: none;
  padding: 16px 32px;
  border-radius: 8px;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: background 0.2s;
}

.btn-accept:hover {
  background: #5568d3;
}

.btn-secondary {
  background: transparent;
  color: #667eea;
  border: 2px solid #667eea;
  padding: 14px 32px;
  border-radius: 8px;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s;
}

.btn-secondary:hover {
  background: #667eea;
  color: white;
}

.btn-primary {
  background: #667eea;
  color: white;
  border: none;
  padding: 14px 32px;
  border-radius: 8px;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: background 0.2s;
}

.btn-primary:hover {
  background: #5568d3;
}

.error-card {
  text-align: center;
}

.error-icon {
  font-size: 64px;
  margin-bottom: 16px;
}

.error-card h2 {
  color: #d9534f;
  margin-bottom: 16px;
}

.error-card p {
  color: #666;
  margin-bottom: 32px;
}

.loading-spinner {
  text-align: center;
  font-size: 18px;
  color: #667eea;
  padding: 40px 0;
}

@media (max-width: 768px) {
  .invitation-card {
    padding: 32px 24px;
  }

  .invitation-header h1 {
    font-size: 24px;
  }

  .offering-name {
    font-size: 22px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/InvitationAcceptance.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,6DAA6D;EAC7D,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,aAAa;EACb,gBAAgB;EAChB,WAAW;EACX,0CAA0C;AAC5C;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,SAAS;AACX;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,WAAW;AACb;;AAEA;EACE,eAAe;EACf,WAAW;AACb;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;EACvB,cAAc;EACd,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA;EACE;IACE,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;AACF","sourcesContent":[".invitation-page {\n  min-height: 100vh;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n  padding: 20px;\n}\n\n.invitation-card {\n  background: white;\n  border-radius: 16px;\n  padding: 48px;\n  max-width: 600px;\n  width: 100%;\n  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);\n}\n\n.invitation-header {\n  text-align: center;\n  margin-bottom: 32px;\n}\n\n.invitation-icon {\n  font-size: 64px;\n  margin-bottom: 16px;\n}\n\n.invitation-header h1 {\n  font-size: 32px;\n  color: #333;\n  margin: 0;\n}\n\n.invitation-body {\n  margin-bottom: 32px;\n}\n\n.invitation-intro {\n  font-size: 18px;\n  line-height: 1.6;\n  color: #555;\n  margin-bottom: 24px;\n}\n\n.role-badge {\n  display: inline-block;\n  background: #f0f0f0;\n  padding: 4px 12px;\n  border-radius: 12px;\n  font-size: 14px;\n  color: #667eea;\n  font-weight: 600;\n}\n\n.offering-name {\n  font-size: 28px;\n  color: #667eea;\n  margin: 24px 0;\n  text-align: center;\n}\n\n.invitation-details {\n  font-size: 16px;\n  line-height: 1.6;\n  color: #666;\n  margin-bottom: 24px;\n}\n\n.invitation-email {\n  background: #f8f9fa;\n  padding: 16px;\n  border-radius: 8px;\n  text-align: center;\n}\n\n.invitation-email p {\n  margin: 0 0 8px 0;\n  font-size: 14px;\n  color: #888;\n}\n\n.invitation-email strong {\n  font-size: 16px;\n  color: #333;\n}\n\n.invitation-actions {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n.btn-accept {\n  background: #667eea;\n  color: white;\n  border: none;\n  padding: 16px 32px;\n  border-radius: 8px;\n  font-size: 16px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: background 0.2s;\n}\n\n.btn-accept:hover {\n  background: #5568d3;\n}\n\n.btn-secondary {\n  background: transparent;\n  color: #667eea;\n  border: 2px solid #667eea;\n  padding: 14px 32px;\n  border-radius: 8px;\n  font-size: 16px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.2s;\n}\n\n.btn-secondary:hover {\n  background: #667eea;\n  color: white;\n}\n\n.btn-primary {\n  background: #667eea;\n  color: white;\n  border: none;\n  padding: 14px 32px;\n  border-radius: 8px;\n  font-size: 16px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: background 0.2s;\n}\n\n.btn-primary:hover {\n  background: #5568d3;\n}\n\n.error-card {\n  text-align: center;\n}\n\n.error-icon {\n  font-size: 64px;\n  margin-bottom: 16px;\n}\n\n.error-card h2 {\n  color: #d9534f;\n  margin-bottom: 16px;\n}\n\n.error-card p {\n  color: #666;\n  margin-bottom: 32px;\n}\n\n.loading-spinner {\n  text-align: center;\n  font-size: 18px;\n  color: #667eea;\n  padding: 40px 0;\n}\n\n@media (max-width: 768px) {\n  .invitation-card {\n    padding: 32px 24px;\n  }\n\n  .invitation-header h1 {\n    font-size: 24px;\n  }\n\n  .offering-name {\n    font-size: 22px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
